import type { IMasterDataProductRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataProductDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataProductUseCase {
  private readonly repository: IMasterDataProductRepository;

  constructor(repository: IMasterDataProductRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataProductDTO) {
    return this.repository.createProduct(params);
  }
}
